<template>
  <div>
      <div class="panel panel-default">
        <div class="panel-heading">
            <div>
                <span>
                    Clients
                </span>
            </div>
        </div>
        <div class="panel-body">
            <table class="table clients">
                <!-- <thead>
                    <tr>
                        <th>Name</th>
                        <th></th>
                    </tr>
                </thead> -->

                <tbody>
                    <tr v-for="client in clients" :key="client.id">
                        <td>
                            <a @click="showClientInfo(client)">
                                {{ client.name }}
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="panel-footer">
            <button class="btn btn-default"  v-show="isAdmin" @click="showNewClientForm">
                <span class="fa fa-building-o"></span> Add a Client
            </button>
        </div>
      </div>

      <div class="modal fade" id="modal-new-client-form" tabindex="-1" role="dialog">
          <div class="modal-dialog">
              <div class="modal-content">
                  <div class="modal-header">
                      <button type="button " class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

                      <h4 class="modal-title">
                          Add a Client
                      </h4>
                  </div>
                  <div class="modal-body">
                      <new-client-form></new-client-form>
                  </div>
                  <!-- Modal Actions -->
                  <div class="modal-footer">
                      <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import NewClientForm from './NewClientForm.vue';

export default {
    components: {
        NewClientForm
    },

    props: ['user','currentTeam'],

    computed: {
        ...mapGetters('client', {
            'clients': 'clients',
            'isAdmin': 'isAdmin',
        })
    },

    mounted() {
        this.prepareComponent();
    },

    methods: {
        prepareComponent() {
            this.setPermissions();
            this.setCurrentTeam();
            this.getClientList();
        },

        ...mapActions('client',{
            'getClientList': 'getAllClients',
        }),

        setCurrentTeam() {
            this.$store.dispatch('client/setCurrentTeam', {
                team: this.currentTeam
            });
        },

        setPermissions() {
            this.$store.dispatch('client/setAuth', {
                auth: this.user.teams[0].pivot
            });
        },

        showClientList() {
            this.$store.dispatch('client/showClientListView');
        },

        showClientInfo(client) {
            history.pushState(null, null, '#/clients/' + client.slug);
            this.$store.dispatch('client/showClientProfile');
            this.loadClientProfile(client);
        },

        loadClientProfile(client) {
            Bus.$emit('load-client-profile', client.slug);
        },

        showNewClientForm() {
            $('#modal-new-client-form').modal('show');
        },
    }
}
</script>

<style scoped>
table.clients td {
    padding-top: 12px;
    padding-bottom: 12px;
}
table.clients tr:first-child td:first-child {
    border-top: none;
    padding-top: 0px;
}
table.clients td a {
    display: block;
}

/* table.clients td a:hover {
    text-decoration: none;
}

.hover-icon {
    display: none;
}

table.clients td a:hover .hover-icon {
    display: inline;
} */
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/ClientList.vue